import React, { createContext, useContext, useMemo } from 'react';
import { useSpaceId } from '../hooks/use-space-id';
export const ChannelContext = createContext(undefined);
/**
 * use instead of React.useContext, throws if not in a Provider
 */
export function useChannelContext() {
    const context = useContext(ChannelContext);
    if (!context) {
        throw new Error('useChannelContext must be used in a ChannelContextProvider');
    }
    return context;
}
export function ChannelContextProvider(props) {
    const { channelId } = props;
    const spaceId = useSpaceId();
    const channelContext = useMemo(() => ({
        channelId: channelId,
        spaceId: spaceId,
    }), [channelId, spaceId]);
    return (React.createElement(ChannelContext.Provider, { value: channelContext }, props.children));
}
//# sourceMappingURL=ChannelContextProvider.js.map